<template>
  <section class="user-select-none">
    <h2 class="mb-0">{{ $t('leashSizeSelect.error') }}</h2>
    <h3 class="text-dark h4">{{ $t('leashSizeSelect.sizeOptionsBelow') }}</h3>
    <b-row class="my-3">
      <b-col v-for="[sizeKey, sizeDetails] in Object.entries(sizes)" :key="sizeKey" class="text-center">
        <b-button
          :id="`product-size-select-${sizeKey}`"
          :ref="sizeKey"
          class="size-option"
          block
          :class="{ 'no-stock': isOutOfStock(sizeDetails), selected: size === sizeKey }"
          :variant="!isOutOfStock(sizeDetails) ? 'outline-primary' : 'outline'"
          :disabled="isOutOfStock(sizeDetails)"
          :title="sizeKey"
          :aria-label="`Choose ${sizeKey}`"
          @focus="setFocus(sizeKey)"
          @focusout="unsetFocus"
          @click="isOutOfStock(sizeDetails) ? null : setSize(sizeKey)"
        >
          <p class="h3 mb-0" :class="isOutOfStock(sizeDetails) ? 'text-light' : 'text-primary'">
            <strong>{{ $t(`productSizeSelect.${sizeKey}.text`) }}</strong>
          </p>
          <svg v-show="isOutOfStock(sizeDetails)" aria-hidden="true"><line x1="0" y1="100%" x2="100%" y2="0" /></svg>
        </b-button>
        <div v-if="isOutOfStock(sizeDetails)" class="text-danger copy" v-text="$t('product.outOfStock')" />
      </b-col>
    </b-row>
    <ValidationProvider v-slot="{ errors }" vid="p-size-select" :rules="{ required: { allowFalse: false } }" slim>
      <input id="product-style-color" v-model="value" type="text" class="d-none" hidden />
      <span v-if="errors && errors[0]" class="text-danger">{{ $t('productSizeSelect.error') }}</span>
    </ValidationProvider>
  </section>
</template>

<script>
import getImage from '@/mixins/getImage';
import { ProductMixins } from '@/mixins/components/product';
import { KeyboardNavigationMixins } from '@/mixins/keyboardNavigation';

export default {
  name: 'EssentialsSizeSelect',
  mixins: [getImage, ProductMixins, KeyboardNavigationMixins],
  computed: {
    selectedSize() {
      let selected = Object.entries(this.sizes)?.find((e) => e?.[0] === this.size);
      return selected || [];
    },
    navigableOptions() {
      let options = [];
      if (!this.disableSmall) {
        options.push('S');
      }
      if (!this.disableLarge) {
        options.push('L');
      }
      return options;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.size-option {
  border-radius: 10px;
  border: 2px solid $dp-gray-4;
  height: auto;
  padding-top: 0.5rem;
  &.selected {
    border: 2px solid $dp-blue;
    background-color: rgba(204, 236, 249, 0.5);
  }
  &:hover,
  &:active,
  &:focus {
    &:not(.disabled) {
      border: 2px solid $dp-blue;
      box-shadow: 0 0 0 0.2rem $dp-light-blue;
      background-color: rgba(204, 236, 249, 0.5) !important;
    }
  }
}
.size-out-of-stock-pop-over {
  &.bs-popover-top {
    top: -10px !important;
  }
  &.bs-popover-bottom {
    top: 10px !important;
  }
  &.bs-popover-right {
    left: 10px !important;
  }
  &.bs-popover-left {
    left: -10px !important;
  }
  @media (min-width: 991px) {
    max-width: 600px;
  }
}
.size-pop-over {
  &.bs-popover-top {
    top: -10px !important;
  }
  &.bs-popover-bottom {
    top: 10px !important;
  }
  &.bs-popover-right {
    left: 10px !important;
  }
  &.bs-popover-left {
    left: -10px !important;
  }
  @media (min-width: 991px) {
    max-width: 600px;
  }
  background-color: $dp-gray-1;
}
.size-collapse {
  border-radius: 6px;
  background-color: $dp-gray-1;
  border: 2px solid $dp-gray-3;
}
</style>
